import { render, staticRenderFns } from "./QuickMenuSetPopView.vue?vue&type=template&id=2a0d4413"
import script from "./QuickMenuSetPopView.ts?vue&type=script&lang=ts&external"
export * from "./QuickMenuSetPopView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports